import { Action } from '@ngrx/store';
import { SiteEmailConfigInterface } from 'app/site-settings/models/site-email-config.model';

import { SiteSettingActionType } from './site-setings-action-type.enum';

export class LoadEmailConfig implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadEmailConfig;

  public readonly payload: any = undefined;
}

export class LoadEmailConfigCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadEmailConfigCompleted;

  constructor(public readonly payload: SiteEmailConfigInterface) { }
}

export class LoadEmailConfigFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadEmailConfigFailed;

  constructor(public readonly payload: string) { }
}
export class UpdateEmailConfig implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateEmailConfig;

  constructor(public readonly payload: SiteEmailConfigInterface) { }
}

export class UpdateEmailConfigCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateEmailConfigCompleted;

  constructor(public readonly payload: SiteEmailConfigInterface) { }
}

export class UpdateEmailConfigFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateEmailConfigFailed;

  constructor(public readonly payload: string) { }
}
